import {FC, ReactNode, useEffect, useRef, useState} from "react";
import {DropdownItem} from "@/components/dropdown/DropdownItem";
import {cn} from "@/core/ui/utils/utils";

interface DropdownProps {
    children: ReactNode;
    className?: ReactNode;
    menu?: ReactNode;
    apart?: boolean;
    direction?: 'up' | 'down';
}

interface DropdownComponent extends FC<DropdownProps> {
    Item: typeof DropdownItem;
}

const Dropdown: DropdownComponent = ({
                                         children,
                                         className,
                                         menu,
                                         apart,
                                         direction = 'up',
                                     }: DropdownProps) => {
    const [isActive, setIsActive] = useState<boolean>(false);
    const wrapper = useRef<HTMLDivElement>(null);
    const dropdown = useRef<HTMLDivElement>(null);

    const handleClick = () => {
        setIsActive(!isActive);
    };

    useEffect(() => {
        const wrapperRef = wrapper.current;
        const dropdownRef = dropdown.current;

        const handleDocumentClick = (event: MouseEvent) => {
            if (
                wrapperRef &&
                dropdownRef &&
                !wrapperRef.contains(event.target as Node) &&
                !dropdownRef.contains(event.target as Node)
            ) {
                setIsActive(false);
            }
        };

        document.addEventListener("click", handleDocumentClick);

        return () => {
            document.removeEventListener("click", handleDocumentClick);
        };
    }, [isActive]);

    return (
        <div
            ref={wrapper}
            onClick={handleClick}
            className={cn(
                `relative flex w-fit cursor-pointer appearance-none ${
                    className || ""
                }`
            )}>
            {children}
            <div
                ref={dropdown}
                className={`${!isActive ? "hidden" : ""}
    absolute ${direction === 'up' ? 'bottom-full' : 'top-14'} left-0 z-30 mb-[4px] flex w-full flex-col`}>
                <div
                    className={`z-50 flex max-h-[310px] min-w-full rounded-lg bg-white animate-transition-${direction} flex-col overflow-hidden overflow-y-auto
         bg-surface-container py-[8px] shadow-mm-1 ${
                        apart && "mb-[4px]"
                    }`}>
                    <>{menu}</>
                </div>
            </div>
        </div>
    );
};

Dropdown.Item = DropdownItem;

export {Dropdown};